(() => {
  'use strict';
  if (customElements.get('yood-builder-announcement')) return;
  const seenKey = 'yood-november-sale-2026-v1';
  class YoodBuilderAnnouncement extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || this.bound) return;
      this.bound = true;
      this.forcePreview = new URLSearchParams(window.location.search).get('yood_popup_preview') === '1';
      if (window.Shopify && window.Shopify.designMode && !this.forcePreview) return;
      try { if (sessionStorage.getItem(seenKey) && !this.forcePreview) return; } catch (_) {}
      this.querySelectorAll('[data-yood-popup-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.restore());
      this.querySelector('a').addEventListener('click', () => this.dialog.close());
      this.attempts = 0;
      this.timer = window.setTimeout(() => this.open(), 1200);
    }
    open() {
      if (!this.isConnected || this.dialog.open) return;
      const busy = document.hidden || Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]:not(.yood-builder-dialog), cart-drawer.active, menu-drawer details[open]')).some(element => !element.closest('details:not([open]), [hidden], [aria-hidden="true"]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0');
      if (busy) {
        if (++this.attempts < 30) this.timer = window.setTimeout(() => this.open(), 1000);
        return;
      }
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.locked = true;
      try { sessionStorage.setItem(seenKey, '1'); } catch (_) {}
    }
    restore() {
      if (!this.locked) return;
      document.body.style.overflow = this.previousOverflow;
      this.locked = false;
      if (this.previousFocus && this.previousFocus.isConnected && typeof this.previousFocus.focus === 'function') this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.restore();
    }
  }
  customElements.define('yood-builder-announcement', YoodBuilderAnnouncement);
})();
